import { StructureNode } from "../timeframe-matching/structure-node";

export class ReportDaySelection {

    date: Date;
    structureNode: StructureNode;

    constructor(selection?: any) {
        if (selection != null) {
            this.date = selection.date;
            this.structureNode = selection.structureNode;
        }
    }

}